module.exports = __webpack_public_path__ + "roboto-blackitalic-webfont.ff7d3c74b6b27eba60e8.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/roboto-blackitalic-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto-blackitalic-webfont.woff
// module chunks = styles